<template>
       <!-- Start Main Content -->
       <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
            <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-2 py-2 sm:p-1 bg-gray-200/30 dark:bg-dark-card-shade">
                <div>
                    <h6 class="card-title">Purchase</h6>
                </div>
                <label>Date : <input type="date"    v-model="purchase.date"></label>
            </div>


                      <div  class = "mt-2" style="margin-left: 10px;">
                        <lable>Invoice Number</lable>
                            <input 
                                                
                                                    type="number" 
                                                    class="form-input" 
                                                    v-model="invoice.invoice_no" 
                                                    style="width: 10%;"
                                                   
                                                
                                                />
                        </div>



            <div class="overflow-x-auto scrollbar-table px-1.5 py-4">
                <table class="table-auto w-full ">
                    <tbody>
                    <tr>
                        <td>Vendor Name <a class="text-danger border px-4" @click="addModal()" >
                                                <i class="ri-add-line text-danger text-[13px]"></i> Add New Vendor
                                            </a></td>
                        <td>Cell</td>
                        <td>GST</td>
                        <td>Address</td>
                    </tr>
                    <tr>
                        <td class="prd_name_col"> <select  class="form-input" id="cust_name" ref="cust_name" v-model="purchase.custid" autofocus>
                                            <option  v-for="(item ,index)  in vendorList" :value="item.id" >{{item.name}}</option>
                                    </select></td>
                        <td class="prd_val_col">{{ purchase.custcell }}</td>
                        <td class="prd_val_col">{{ purchase.custgst }}</td>
                        <td class="prd_val_col">{{ purchase.custaddress }}</td>
                    </tr>
                    </tbody>
                </table>

            </div>

             
            <!-- Start All Language List Table -->
            <div class="p-3 sm:p-4"> 
                <div class="overflow-x-auto scrollbar-table">
                    <table class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none">
                        <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                            <tr class="bg-gray">
                                <th class="px-1.5 py-4 prd_barcode_col">Barcode</th>
                                <th class="px-1.5 py-4 prd_val_col">HSN</th>
                                <th class="px-1.5 py-4 prd_name_col">Name</th>
                                <th class="px-1.5 py-4">GST</th>
                                <th class="px-1.5 py-4 prd_val_col ">Rate</th>
                                <th class="px-1.5 py-4 prd_val_col">Qty</th>
                                <th class="px-1.5 py-4 prd_val_col right">Total</th>
                                <th class="px-1.5 py-4 px-4"> <i class="ri-settings-3-line text-inherit text-[13px]"></i></th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                            <tr  class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white " v-for="(item ,index)  in purchase_product_list" :value="item.id" >
                                <td class="">{{item.barcode }}</td>
                                <td class="">{{item.hsn}}</td>
                                <td class="">{{item.prdname}} </td>
                                <td class="text-center">{{item.gst}}</td>
                                <td class=""><input type="text"  class="form-input right" v-model="item.prate"   @input="getTotal_added(item)" /></td> 
                                <td class=""><input type="text"  class="form-input text-center" v-model="item.qty"  @input="getTotal_added(item)"  /></td>
                                <td class="right">{{item.total}}</td>
                                 <td class="px-4">
                                    <div class="flex items-center gap-1"> 
                                        <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                            <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>



                            <tr class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white entry_row" > 
                                <td class=""><input type="text" class="form-input" ref="barcode" v-model="prd.barcode"></td>
                                <td class="">{{prd.hsn}}</td>
                                <td class="">
                                    <select  class="form-input" id="prd_name" ref="name" v-model="prd.prdid">
                                            <option  v-for="(item ,index)  in productsList" :value="item.id" >{{item.name}}</option>
                                    </select>

                                     </td>
                                <td class="">{{prd.gst}}</td>
                                <td class=""><input type="text" class="form-input text-center" ref="prate" v-model="prd.prate" @input="getTotal()"></td> 
                                <td class=""><input type="text" class="form-input text-center" ref="qty" id="qty" v-model="prd.qty" @input="getTotal()" v-on:keyup.enter="addToCart()" ></td>
                                <td class=""><input type="text" class="form-input" v-model="prd.total"  @keyup.enter="addToCart()" ></td>
                                <td class="">
                                    <div class="flex items-center gap-1">
                                        <button class="btn-icon btn-primary-icon-light size-7"  @click="addToCart()"  >
                                            <i class="ri-add-line text-inherit text-[13px]"></i>
                                        </button>
                                        <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                            <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            
                        </tbody>
                    </table>
                </div> 
                
            <div class="overflow-x-auto scrollbar-table px-1.5 py-4">
                <table class="table-auto w-full ">
                    <tbody>
                    <tr>
                        <td>Total Amount</td>
                        <td>Total Quantity</td>
                        <td>GST</td>
                        <td>Paid</td>
                        <td>Remark</td>
                    </tr>
                    <tr>
                        <td class=""><b>{{account.total}}</b></td>
                        <td class=""><b>{{account.qty}}</b></td>
                        <td class=""><b>{{account.gst}}</b></td>
                        <td class="prd_barcode_col"><input type="text" class="form-input text-center" @input="getFinalTotal()" v-model="account.paid" v-on:keyup.enter="reamrk_focus" ></td>
                        <td class="prd_name_col"><input type="text" class="form-input text-center" ref="reamrk_focus" v-model="account.remark" v-on:keyup.enter="save_focus"></td>
                    </tr>
                    </tbody>
                </table>

            </div>
            <div>
                <h5 v-if="account.due>0" class="text-danger">Due Amount : {{account.due}}</h5>
            </div>
             <div class="flex   mt-7">
                            <button @click="save_bill" ref="save_focus" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                        </div> 
            </div>

           
            <!-- End All Language List Table -->
        </div>
    </div>
    <!-- End Main Content -->

    <!-- Start Edit Modal -->
    <div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
              
                <div class="p-4 md:p-5" >
                      <form>
                    <div class="mt-5" v-on:keyup.enter="nextFocus">
                        <div class="mt-5">
                            <label for="tagname" class="form-label">Vendor Name *</label>
                            <input type="text" v-model="Vendor.name" class="form-input" id="first_input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="mt-5">
                            <label for="tagname" class="form-label">Vendor Contact *</label>
                            <input type="text" v-model="Vendor.cell" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="mt-5">
                            <label for="tagname" class="form-label">Vendor GST No *</label>
                            <input type="text" v-model="Vendor.gst" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div>
                        <div class="mt-5">
                            <label for="tagname" class="form-label">Vendor Address *</label>
                            <input type="text" v-model="Vendor.address" class="form-input" placeholder="Type Here..." autocomplete="off" required >
                        </div> 
                    </div>
                    </form>

                        <div class="flex justify-end mt-5">
                            <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                        </div> 
                </div>
            </div>
        </div>
    </div>
    <!-- End Edit Modal -->

    <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_Vendor()" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
</template>
<style scoped>
.form-input{
    height: 20px;
    padding: 15px 2px;
    border: 1px solid black;
    color: black;

}
thead tr{
    background: #95d2ff3b;
}
.select2.select2-container .select2-selection{
    height: 25px;
}
.select2-selection__arrow{
    display: none;
}
.prd_name_col{
    width: 350px;  
}
.prd_val_col{
    width: 80px;  
}
.prd_barcode_col{
    width: 150px;  
}
.entry_row{
    background: beige;
}
.select2-container{
    width: 100% !important;
}
td{
    color: black;
}
.right{
    text-align: right;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
  name: 'purchaseView',
  components: {
    
  } ,
  mounted(){
    this.getBasics();
   
  },
  data() {
    return {
        isAdd:0,
        isEdit:0,
        isDelete: 0,
        deleteId:0,
        productsList:[],
        vendorList:[],
        selectedProduct:[],
        purchase_product_list:[],
        Vendor:{name:'',cell:'',address:'',gst:''},
        prd:{},
        purchase:{custcell:'',custgst:'',custaddress:'',custid:'',date:this.todayDate()},
        account:{total:0,qty:0,gst:0,paid:0,remark:''},
        prd_select_tag:null,
        employees: {empname:'',emprole:'0',isMainAdmin:0},


        invoice:{
            invoice_no:0,
        },



    }
    }, 
  methods:{
    todayDate()
    {
        const dateObj = new Date();
        var month=dateObj.getMonth()+1;
        var day=dateObj.getDate()+1;
        const currentDate = dateObj.getFullYear()+"-"+((month<10)?'0'+month:month)+"-"+((day<10)?'0'+day:day);
        return currentDate;
    },
    closeModal(){
        
            $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
    },
    addModal(){
        this.Vendor={name:'',cell:'',address:'',gst:''};

        if(!this.isAdd)
            $("#editModal").removeClass('hidden');
        else
            $("#editModal").addClass('hidden');

            $("#first_input").focus();
        this.isAdd=!this.isAdd;
    },
    nextFocus(e) {
            const inputs = Array.from(e.target.form.querySelectorAll('input'));
            const index = inputs.indexOf(e.target);

            if (index < inputs.length) {
                try {
                    inputs[index + 1].focus();
                    inputs[index + 1].select();
                } catch (error) {
                    $("#saveBtn").focus();
                }
            }
        },
    editModal(item){
        if(item){
            let copy = JSON.parse(JSON.stringify(item));
            this.cat=copy;
        }
        if(!this.isEdit)
            $("#editModal").removeClass('hidden');
        else
            $("#editModal").addClass('hidden');
        this.isEdit=!this.isEdit;
    },
    
    deleteModal(id){
        this.deleteId=id;
        if(!this.isDelete)
            $("#deleteModal").removeClass('hidden');
        else
            $("#deleteModal").addClass('hidden');
        this.isDelete=!this.isDelete;
    },
    getTotal_added(item){
        try {
                item.total=parseFloat(item.qty)*parseFloat(item.prate);
                this.getFinalTotal();
        } catch (error) {
            
        }
    },
    getFinalTotal(){
        try {
            var total_amt=0;
            var total_qty=0;
            this.purchase_product_list.forEach(item => {
                total_amt+=parseFloat(item.qty)*parseFloat(item.prate);;
                total_qty+=parseFloat(item.qty);
            });

            this.account.total=total_amt.toFixed(2);
            this.account.qty=total_qty.toFixed(2);
            
            //as per 5%
            this.account.gst=(total_amt*(5/100)).toFixed(2);
            if(this.account.paid)
                this.account.due=(total_amt- parseFloat(this.account.paid)).toFixed(2);

        } catch (error) {
            
        }
    },
    getTotal(){
        try {
            this.prd.total=parseFloat(this.prd.qty)*parseFloat(this.prd.prate);
            this.getFinalTotal();
        } catch (error) {
            
        }
    },
    async getBasics() {
          var self=this;
            axios.post('getPurchasesBasic').then(function (response) {
                    self.productsList=response.data.products;
                    self.vendorList=response.data.vendors; 
                    self.employees=response.data.userDetails;
                   }).then(()=>{
                                 self.prd_select_tag= $("#prd_name").select2({
                                    width: '100%',
                                    dropdownAutoWidth : true,
                                    placeholder:"Search Product Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a ref='add_product' class='  btn-primary-icon-light size-7'>Add Product</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                  }).on('change', function (event) {
                                        self.selectedProduct = self.productsList.find(item => item.id === event.target.value);
                                        self.prd=self.selectedProduct;
                                        self.prd.prdname=self.selectedProduct.name;
                                        setTimeout(() => { self.$refs.qty.focus() }, 300)
                                        // self.$refs.qty.focus();
                                    });  

                                    $("#cust_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Vendor Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) {
                                        var selected_Vendor = self.vendorList.find(item => item.id === event.target.value);
                                            self.purchase.custid=selected_Vendor.id;
                                            self.purchase.custcell=selected_Vendor.cell;
                                            self.purchase.custgst=selected_Vendor.gst;
                                            self.purchase.custaddress=selected_Vendor.address;
                                            self.prd_select_tag.select2('open');
                                        });  
                        });

                  
     },
     alerty(){
        alert('Hello');
     },
     save() {
                var self = this; 
                if(self.Vendor.name==''){
                    self.$swal("Vendor Name is Required");
                }else{
                    axios.post('addVendor', this.Vendor)
                        .then(response => {
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            self.vendorList=response.data.list;
                            self.employees=response.data.userDetails;
                            self.Vendor={name:'',cell:'',address:'',gst:''};

                            //self.$swal(msg);
                            if (isSuccess == 1) {
                                self.closeModal();
                            }
                        })
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                }
            },
            save_bill() {
                var self = this; 
                if(self.purchase.custid=='')
                    self.$swal("Please Select Vendor...");
                else if(self.purchase_product_list.length==0)
                    self.$swal("Please Select Products...");
                else{
                    axios.post('addPurchasesBill', {invoice_number:self.invoice,purchase:self.purchase,purchase_items:JSON.stringify(self.purchase_product_list ),account:self.account})
                        .then(response => {
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                           // self.productsList=response.data.list;
                            self.employees=response.data.userDetails;
                            self.Vendor={name:'',cell:'',address:'',gst:''};

                            self.$swal(msg);
                            if (isSuccess == 1) {
                                self.closeModal();
                            }
                        })
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                }
            },
             
            addToCart(){
                if(this.prd.prate && this.prd.qty){
                    this.purchase_product_list.push({...this.prd});
                    this.prd={};
                    
                    this.prd_select_tag.select2('open');
                    this.getFinalTotal();
                }

            },

             save_focus() {
            this.$refs.save_focus.focus();
        },

           reamrk_focus() {
            this.$refs.reamrk_focus.focus();
        },


  }
}
</script>
